export default function storeRowDetail(state = { rowData: (localStorage.getItem("rowdata") ? JSON.parse(localStorage.getItem("rowdata")) : ""), keyRecieved: false }, action) {
    switch (action.type) {
        case 'ROW_STATE':
            return {
                rowData: action.payload
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer/storerowdetail.jsx